module.exports = __webpack_public_path__ + "img/strip-20.ffd25414.jpg";